import { useState, useEffect, useRef } from 'react'

function useActions(name) {
  const [activePopover, setActivePopover] = useState(null)
  const stateRef = useRef(activePopover)
  const wrapperRef = useRef(null)
  const triggerRef = useRef(null)

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    /* eslint-disable-next-line no-undef */
    App.events.subscribe('top:menu:popover:hide', setInactive)
    App.events.subscribe('top:menu:cart:open', showCart)
    App.events.subscribe('top:menu:cart:close', hideCart)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      /* eslint-disable-next-line no-undef */
      const unsub = App.events.unsubscribe || App.events.remove
      unsub.call(App.events, 'top:menu:popover:hide', setInactive)
      unsub.call(App.events, 'top:menu:cart:open', showCart)
      unsub.call(App.events, 'top:menu:cart:close', hideCart)
    }
  }, [])

  function setInactive() {
    updateState(false)
  }

  function showCart() {
    // If this is the cart action and it's not already open, trigger a click to ensure widget loads
    if (name === 'cart-action' && stateRef.current !== 'cart-action' && triggerRef.current) {
      triggerRef.current.click()
    } else if (stateRef.current !== 'cart-action') {
      updateState('cart-action')
    }
    // If cart is already open, do nothing (don't toggle it closed)
  }

  function hideCart() {
    if (stateRef.current === 'cart-action') {
      updateState(false)
    }
  }

  function handleClickOutside(e) {
    // basically check that popover for this action is open
    if (name === stateRef.current) {
      const wrapper = wrapperRef.current
      const trigger = triggerRef.current

      if (!trigger.contains(e.target) && !wrapper.contains(e.target)) {
        return updateState(false)
      }
    }

    return null
  }

  function updateState(val) {
    stateRef.current = val
    setActivePopover(val)
  }

  return {
    activePopover,
    updatePopover: updateState,
    wrapperRef,
    triggerRef,
  }
}

export { useActions }
